module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch2"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/chap2.jpg",
      "width": "8%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Actually, I knew why we were here. I knew it but I didn’t really believe it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This was step one. The first part of our plan to make ourselves braver.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Halloween was coming soon. We had to toughen ourselves up. We had to be prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Amanda and I talked about it for days. If we made ourselves tougher and less afraid, we could change our lives. And we could get what every frightened, timid person in the world wants. You guessed it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Revenge.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("First, I wanted to get revenge against my darling little sister, Rita.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This morning, Rita went into the bathroom before I woke up, emptied my mouthwash bottle, and filled it with some kind of red food coloring.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I know, I know. Most kids don’t use mouthwash in the morning. But I have a thing about mouth germs. Don’t judge me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was half-awake. I took a mouthful of the stuff and swished it around my mouth. Yuck. It tasted weird. I gazed in the mirror. I had RED TEETH! Red gums. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blood all over my mouth. Blood!")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Did I scream in panic? Of course. You would, too, if you thought your mouth was dripping blood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I could hear Rita laughing all the way from the kitchen downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So, yes, number one on my list is revenge against Rita.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And, of course, Amanda and I were eager to get revenge on Mickey and Morty. We weren’t just eager, we were desperate to pay them back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Did I mention their hobby is torturing Amanda, too?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So here we were, ready to prove to each other that we could change. We could become brave people in time for Halloween.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was wearing a wool cap pulled down over my ears, my winter parka, and a woolly sweater underneath it. But I was still shivering. Amanda had her hands tucked deep in the pockets of her coat. A long blue scarf, wrapped round and around her, covered her mouth and nose.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The air was cold, and gusts of wind kept pushing against us, as if telling us to turn around and go home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sky was almost as dark as night. In the old graveyard behind us, the trees cracked and creaked in the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Did I mention that the graveyard is just one block from where Amanda and I live? And that Lucky Me has to walk past it every morning and every afternoon to and from school?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, I’m terrified of graveyards, and this one is particularly frightening. The gravestones are old, mostly rubbed smooth, cracked and tilted in every direction. It looks to me like the dead people have pushed up from under the ground, knocked over their tombstones as they pulled themselves up from their graves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s my worst nightmare. Well … "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("one")]), _vm._v(" of them. That I’ll be walking past the graveyard, and I’ll see bony hands clawing the ground, someone slapping at the carpet of dead leaves from underground. A dead person … a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("zombie")]), _vm._v(" — pulling himself up from the cold, hard dirt. And then come staggering blindly toward me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s a bad nightmare, right? Don’t snicker or laugh. If you lived one block from a graveyard, you might have that nightmare, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I pulled the collar of my coat higher. “Amanda, are we really doing this? Is this really going to make us braver? Are we making a big mistake?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shut up,” she said. “Stop talking.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But —”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ve already decided,” she said, crossing her coat sleeves in front of her. “So shut up. And let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I nodded. She was right. She knew me. She knew the Scott Harmon method for staying out of trouble. Just talk about doing something forever but don’t really do it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But like I said, we were desperate. We had to prove that we could be brave. We were going into the old, abandoned house. We had planned it, and now we were doing it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Amanda took the first step onto the stoop and I followed. The stairs were made of some kind of gray stone, but they were cracked and crumbling.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No one had lived in this old house for a long, long time. Except maybe the ghosts. Everyone said the place was haunted. Everyone said weird howls and shrill cries rose from the house late at night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I don’t believe in ghosts. I mean, I don’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("want")]), _vm._v(" to believe in ghosts. So I sure hoped I wasn’t going to run into any.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Amanda and I climbed the three steps of the front stoop. The front door was black, the paint peeling. I didn’t see a doorbell. I mean, I didn’t plan to ring the bell. I just didn’t see one. The house was so old, maybe doorbells weren’t invented then.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you bring your phone?” Amanda asked. Her voice suddenly sounded tiny. Or was it just muffled by the swirling wind?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I tapped my jeans pocket. “Of course,” I said. “I have it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The plan, you see, was to sneak into the house, explore some rooms, and take pictures of us standing in there. The pictures would prove to the others that we were brave enough to go inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Amanda tilted her head toward the doorknob. “Try the door,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why don’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v("?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, wow. Nice start,” she snapped. “Totally brave, Scott. I’m impressed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you’re going to be sarcastic, we can do this some other time,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She just stared at me with her cold blue eyes. I knew that stare. It meant "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("don’t mess with me")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I wrapped my hand around the pitted brass knob. Twisted it one way, then the other. I tried pulling the door open. Then I tried pushing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then I heard the raspy shout, a deep, angry, bellowing cry: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Go away! Go away from my house!”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bd70c95","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545754088_ch002.vue
// module id = 69
// module chunks = 0